import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuildingUser } from '@fortawesome/free-solid-svg-icons/faBuildingUser';
import type { IconProps } from '../../types';

export function BuildingUserIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Building User',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faBuildingUser}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
